import React, { Fragment, useEffect, useState } from "react";
import { defineMessages, injectIntl } from "react-intl";
import { Section } from "react-native-responsive-layout";
import { FormSpy } from "react-final-form";
import { graphql, withApollo } from "react-apollo";
import { ThemeProvider, withTheme } from "styled-components/native";
import {
  boolean as yupBoolean,
  string as yupString,
  object as yupObject,
  array as yupArray
} from "yup";
import {
  Button,
  Container,
  DeletableItem,
  FormCell,
  FormTextField,
  FormPasswordField,
  FormCheckbox,
  FormEmailField,
  FormSelectRecordField,
  FormToManyField,
  // FormUploadDocumentField,
  FormUploadImageField,
  RoundedIcon,
  ToastContext,
  Label
} from "cci-component";
import {
  findApplicationUserByIdQuery,
  saveApplicationUserMutation,
  deleteApplicationUserMutation,
  findUserGroupsByNameQuery,
  SessionQuery,
  emailNewUserMutation,
  // emailQRCode,
  findRepeatedEmailQuery,
  findBusinessesByNameQuery,
  getSessionInformation,
  findBusinessByIdQuery,
  findApplicationUserByIdAndUBQuery,
  saveApplicationUserUBMutation
} from "cci-data";
import { SecuredComponent } from "cci-logic";
import { localize, withRouter } from "cci-utility";
import FormGeneralStatusField from "../../form/FormGeneralStatusField";
import ImmutableInspect from "../../inspect/ImmutableInspect";
import MutableInspect from "../../inspect/MutableInspect";
import { InspectSubtitle } from "../../layout/Titles";
import PasswordComponent from "./PasswordComponent";
import BusinessSelectionDialog from "../business/SelectionDialog";

const messages = defineMessages({
  user: {
    id: "user",
    defaultMessage: "User"
  },
  firstName: {
    id: "firstName",
    defaultMessage: "First Name"
  },
  lastName: {
    id: "lastName",
    defaultMessage: "Last Name"
  },
  password: {
    id: "password",
    defaultMessage: "Password"
  },
  fastLogin: {
    id: "fastLogin",
    defaultMessage: "Fast Login"
  },
  emails: {
    id: "emails",
    defaultMessage: "E-mails"
  },
  phones: {
    id: "phones",
    defaultMessage: "Phones"
  },
  groups: {
    id: "groups",
    defaultMessage: "Groups"
  },
  selectGroup: {
    id: "selectGroup",
    defaultMessage: "Select a group..."
  },
  atLeastOneEmailRequired: {
    id: "atLeastOneEmailRequired",
    defaultMessage: "You must enter at least 1 e-mail"
  },
  atLeastOneGroupRequired: {
    id: "atLeastOneGroupRequired",
    defaultMessage: "You must enter at least 1 group"
  },
  confirmDeleteItem: {
    id: "confirmDeleteItem",
    defaultMessage: "Are you sure you want to delete this item?"
  },
  alreadyExists: {
    id: "alreadyExists",
    defaultMessage: "This email address {value} already exists."
  },
  additionalBusinessAccess: {
    id: "additionalBusinessAccess",
    defaultMessage: "Additional Business Access"
  },
  changeBusiness: {
    id: "changeBusiness",
    defaultMessage: "Change Business"
  },
  userMovedOK: {
    id: "userMovedOK",
    defaultMessage: "User moved successfully"
  },
  qrCode: {
    id: "qrCode",
    defaultMessage: "Reset 2FA"
  },
  qrCodeSentOK: {
    id: "qrCodeSentOK",
    defaultMessage: "QR Code sent to the user e-mail address"
  },
  qrCodeNotSent: {
    id: "qrCodeNotSent",
    defaultMessage: "An error happened. QR Code not sent"
  },
  smsConsent: {
    id: "smsConsent",
    defaultMessage: "Two Factor Authentication (2FA) is enabled. By filling in these fields you consent to receive the 2FA code via SMS from ProScripts."
  },
});

const MyEmailField = ({ client, theme, name, push, index, value, disabled, foundRpt, setFoundRpt }) => {
  const [errorRpt, setErrorRpt] = useState(false)

  return (
    <ToastContext.Consumer>
      {toast => (
        <ThemeProvider
          theme={{
            fieldBorderColor: errorRpt ? theme.fieldErrorColor : theme.fieldBorderColor,
            fieldBorderTopWidth: errorRpt ? 2 : theme.fieldBorderTopWidth,
            fieldBorderRightWidth: errorRpt ? 2 : theme.fieldBorderRightWidth,
            fieldBorderBottomWidth: errorRpt ? 2 : theme.fieldBorderBottomWidth,
            fieldBorderLeftWidth: errorRpt ? 2 : theme.fieldBorderLeftWidth,
            fieldStyle: "border-style: solid; height: 35px"
          }}
        >
          <FormEmailField
            name={`${name}.address`}
            margins="0 0 0 10px"
            width="200px"
            disabled={disabled}
            onBlur={({ nativeEvent: { text } }) => {
              let tmp = foundRpt;

              client.query({
                query: findRepeatedEmailQuery,
                variables: {
                  emailAddress: text,
                  notId: value && value[index] && value[index].id ? value[index].id : ""
                },
                fetchPolicy: "no-cache"
              })
                .then(({ data }) => {

                  if (text && data && data.findRepeatedEmail && data.findRepeatedEmail.length > 0) {
                    toast.error(messages.alreadyExists, { value: text });

                    setErrorRpt(true);

                    if (!tmp.find(foundRX => foundRX.rx === text)) {
                      tmp.push({ rx: text, ids: data.findRepeatedEmail.map(tr => tr.id) });
                      setFoundRpt(tmp);
                    }
                  } else {
                    setErrorRpt(false);
                    push && push()
                  }

                })
                .catch(res => console.log('err', res))
            }}
            // disabled={disabled && !getState().hasSubmitErrors}
          />
        </ThemeProvider>
      )}
    </ToastContext.Consumer>
  )
};

/**
 * Inspect component for the ApplicationUser entity, allows the user to create, edit or delete records if they have permission to do so.
 */
const Inspect = ({
  intl,
  data,
  theme,
  client,
  history,
  isMutable = true,
  moreItems: MoreItems,
  changeBusiness,
  ...restProps
}) => {
  const [foundRpt, setFoundRpt] = useState([]),
    [businessData, setBusinessData] = useState(null),
    [businessVisible, setBusinessVisible] = useState(false),
    InspectComponent = isMutable ? MutableInspect : ImmutableInspect,
    passwordRegExp = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/,
    passwordValidation = yupString().when("fastLogin", (fastLogin, schema) => {
      if (fastLogin) {
        return schema;
      } else {
        schema = schema
          .min(8, "minimum8")
          .matches(passwordRegExp, "invalidPasswordFieldError");
        if (restProps.match.params.id === "new") {
          return schema.required();
        } else {
          return schema;
        }
      }
    }),
    phoneRegex = /^\+[1]\d{8,12}$/,
    BottomComponent = ({
      form,
      loadingSave,
      setSaving
    }) =>
      businessData && !loadingSave ? (
        <Fragment>
          {/* Commented because MFA is going to be via SMS. */}
          {/* <Button
            margins="0 15px"
            title={messages.qrCode}
            disabled={!form.getState().pristine || form.getState().hasSubmitErrors}
            onPress={() => {
              setSaving(true)
              client
                .mutate({
                  mutation: emailQRCode,
                  variables: {
                    email: form.getState().values.contact.emails[0].address
                  }
                })
                .then(() => {
                  setSaving(false)
                  toast.success(messages.qrCodeSentOK);
                })
                .catch(err => {
                  console.log("err", err)
                  setSaving(false)
                  toast.error(messages.qrCodeNotSent);
                });
            }}
          /> */}
          <Button
            margins="0 15px"
            title={messages.changeBusiness}
            disabled={!form.getState().pristine || form.getState().hasSubmitErrors}
            onPress={() => {
              setBusinessVisible(true)
              // setSaving(true)
            }}
          />
        </Fragment>
      ) : null;

  useEffect(() => {
    client.query({
      query: findBusinessByIdQuery,
      variables: {
        id: data.sessionInformation.currentBusiness.id
      }
    })
      .then(({ data: business, loading }) => {
        if (!loading) {
          setBusinessData(business.findBusinessById);
        }
      });
  }, [])

  return (
    <InspectComponent
      title={messages.user}
      entityName="ApplicationUser"
      query={theme.hideUserBusinesses ? findApplicationUserByIdQuery : findApplicationUserByIdAndUBQuery}
      queryName={theme.hideUserBusinesses ? "findApplicationUserById" : "findApplicationUserByIdAndUB"}
      mutation={theme.hideUserBusinesses ? saveApplicationUserMutation : saveApplicationUserUBMutation}
      mutationName={theme.hideUserBusinesses ? "saveApplicationUser" : "saveApplicationUserUB"}
      objectWrapper="userDTO"
      defaultValues={{
        status: "active",
        fastLogin: false,
        contact: {
          type: "person"
        }
      }}
      validationSchema={yupObject().shape({
        fastLogin: yupBoolean(),
        contact: yupObject().shape({
          firstName: yupString().required(),
          lastName: yupString().required(),
          emails: yupArray()
            .required("atLeastOneEmailRequired")
            .min(1, "atLeastOneEmailRequired")
            .of(
              yupObject().shape({
                address: yupString()
                  .required()
                  .email("invalidEmailFieldError")
                  .test(
                    "notRepeatedEmail",
                    "notRepeatedEmail",
                    function (value) {
                      const found = foundRpt.find(foundRX => value === foundRX.rx && !foundRX.ids.find(id => id === this.parent.id));

                      return !found;
                    }
                  )
              })
            ),
          phones: yupArray()
            .test(
              "atLeastOnePhoneMfa",
              "atLeastOnePhoneMfa",
              value => {
                if (businessData.mfaEnabled && !value) {
                  return false
                }
                if (businessData.mfaEnabled && value && value.length === 0) {
                  return false
                }
                return true
              }
            )
            .of(
              yupObject().shape({
                phoneNumber: yupString()
                  .matches(phoneRegex, "invalidPhoneFormat")
                  .required()
              })
            )
        }),
        groups: yupArray()
          .required("atLeastOneGroupRequired")
          .min(1, "atLeastOneGroupRequired")
          .of(
            yupObject()
              .required()
              .nullable()
          ),
        password: passwordValidation
      })}
      footerAddedComponent={changeBusiness && BottomComponent}
      deleteMutation={deleteApplicationUserMutation}
      afterMutate={({ initialValues, options }) => {
        if (
          options.variables.userDTO.contact.emails[0].address &&
          options.variables.userDTO.password &&
          theme.emailNewUser
        ) {
          setTimeout(() => {
            client
              .mutate({
                mutation: emailNewUserMutation,
                variables: {
                  emailAddress:
                    options.variables.userDTO.contact.emails[0].address || initialValues.contact.emails[0].address,
                  password: options.variables.userDTO.password
                }
              })
              .then(deata => console.log("response", deata))
              .catch(err => console.log("err", err));
          }, 2000);
        }
      }}
      {...restProps}
    >
      {({ form }) => (
        <SessionQuery>
          {({ wrapBusiness }) => (
            <React.Fragment>
              {!theme.hideUserInspectPhoto && (
                <Section>
                  {/* Photo */}
                  <FormCell size="stretch">
                    <FormUploadImageField
                      name="contact.photoId"
                      size={140}
                      border={4}
                      entityName="Contact"
                      alignSelf="center"
                    />
                  </FormCell>
                </Section>
              )}

              {!theme.hideUserInspectFastLogin && (
                <Section>
                  {/* Fast Login */}
                  <FormCell size="stretch">
                    <FormCheckbox
                      leftLabel={messages.fastLogin}
                      name="fastLogin"
                      alignSelf="flex-end"
                      disabled={!isMutable}
                    />
                  </FormCell>
                </Section>
              )}

              <Section>
                {/* First Name */}
                <FormCell xlSize="37%">
                  <FormTextField
                    label={messages.firstName}
                    name="contact.firstName"
                    disabled={!isMutable}
                  />
                </FormCell>

                {/* Last Name */}
                <FormCell xlSize="stretch">
                  <FormTextField
                    label={messages.lastName}
                    name="contact.lastName"
                    disabled={!isMutable}
                  />
                </FormCell>

                {/* Status */}
                <FormCell xlSize={150}>
                  <FormGeneralStatusField isDisabled={!isMutable} />
                </FormCell>
              </Section>

              {/* Password field is shown only when fastLogin is false */}
              <FormSpy>
                {({ form: { getFieldState } }) =>
                  getFieldState("fastLogin") &&
                    !getFieldState("fastLogin").value ? (
                    <Section>
                      {/* Password */}
                      <FormCell xlSize="37%">
                        <FormPasswordField
                          label={messages.password}
                          name="password"
                          disabled={!isMutable}
                        />
                      </FormCell>
                    </Section>
                  ) : theme.hideUserInspectFastLogin ? (
                    <Section>
                      {/* Password */}
                      <FormCell xlSize="37%">
                        <PasswordComponent disabled={!isMutable} />
                      </FormCell>
                    </Section>
                  ) : null
                }
              </FormSpy>

              {/* E-mails */}
              <InspectSubtitle title={messages.emails} />

              <FormToManyField
                name="contact.emails"
                addValidation={yupObject().shape({
                  address: yupString()
                    .required()
                    .email()
                })}
                renderNewOnButton={theme.renderNewOnButton}
              >
                {({ name, isNew, push, value, remove, index, plus, length }) => (
                  <Container
                    key={name}
                    flexDirection="row"
                    alignItems="center"
                    paddings="10px"
                  >
                    {isMutable ? (
                      <DeletableItem
                        allowDelete={!isNew}
                        height="60px"
                        confirmMessage={messages.confirmDeleteItem}
                        onConfirm={remove}
                        checkPermissions={{
                          objects: "ContactEmail",
                          actions: ["delete"]
                        }}
                      >
                        {/* E-mail or add icon */}
                        <RoundedIcon
                          iconSize={50}
                          color={
                            theme.roundedIconColor ||
                            theme.fieldFontColor ||
                            theme.fontColor
                          }
                          name={isNew ? "plus-circle" : "envelope"}
                        />
                      </DeletableItem>
                    ) : (
                      <RoundedIcon
                        iconSize={50}
                        color={
                          theme.roundedIconColor ||
                          theme.fieldFontColor ||
                          theme.fontColor
                        }
                        name={isNew ? "plus-circle" : "envelope"}
                      />
                    )}

                    {/* E-mail address field */}
                    <MyEmailField
                      {...{ client, theme, name, push, index, value, foundRpt, setFoundRpt }}
                      disabled={!isMutable}
                    />

                    {/* New Item Button */}
                    <SecuredComponent
                      checkPermissions={{
                        objects: "ContactEmail",
                        actions: ["create"]
                      }}
                    >
                      {!isNew &&
                        index + 1 === length &&
                        theme.renderNewOnButton &&
                        isMutable ? (
                        <Button
                          leftIcon="plus"
                          margins="0 0 0 10px"
                          ui="dangerLink"
                          leftIconWeight={900}
                          onPress={plus}
                        />
                      ) : null}
                    </SecuredComponent>
                  </Container>
                )}
              </FormToManyField>

              {/* Phones */}
              <InspectSubtitle title={messages.phones} />
              {businessData && businessData.mfaEnabled && (
                <Label fontSize={10}>{localize(intl, messages.smsConsent)}</Label>
              )}

              <FormToManyField
                name="contact.phones"
                addValidation={yupObject().shape({
                  phoneNumber: yupString()
                })}
                renderNewOnButton={theme.renderNewOnButton}
              >
                {({ name, isNew, push, remove, value, index, plus, length }) => (
                  <Container
                    key={name}
                    flexDirection="row"
                    alignItems="center"
                    paddings="10px"
                  >
                    {isMutable ? (
                      <DeletableItem
                        allowDelete={!isNew}
                        height={60}
                        iconName="times"
                        confirmMessage={messages.confirmDeleteItem}
                        onConfirm={remove}
                        checkPermissions={{
                          objects: "ContactPhone",
                          actions: ["delete"]
                        }}
                      >
                        {/* E-mail or add icon */}
                        <RoundedIcon
                          iconSize={50}
                          color={
                            theme.roundedIconColor ||
                            theme.fieldFontColor ||
                            theme.fontColor
                          }
                          name={isNew ? "plus-circle" : "phone"}
                        />
                      </DeletableItem>
                    ) : (
                      <RoundedIcon
                        iconSize={50}
                        color={
                          theme.roundedIconColor ||
                          theme.fieldFontColor ||
                          theme.fontColor
                        }
                        name={isNew ? "plus-circle" : "phone"}
                      />
                    )}

                    <FormTextField
                      margins="0 0 0 10px"
                      label={messages.number}
                      name={`${name}.phoneNumber`}
                      onChangeText={text => {
                        if (text.slice(0, 1) !== "+" && text.slice(0, 2) !== "+1") {
                          form.getFieldState(`${name}.phoneNumber`).change("+1" + text)
                        }
                      }}
                      onBlur={push}
                      disabled={!isMutable}
                      width="200px"
                    />

                    {/* New Item Button */}
                    <SecuredComponent
                      checkPermissions={{
                        objects: "ContactPhone",
                        actions: ["create"]
                      }}
                    >
                      {!isNew &&
                        index + 1 === length &&
                        theme.renderNewOnButton &&
                        isMutable && (
                          <Button
                            leftIcon="plus"
                            margins="0 0 0 10px"
                            ui="dangerLink"
                            leftIconWeight={900}
                            onPress={plus}
                          />
                        )}
                    </SecuredComponent>
                  </Container>
                )}
              </FormToManyField>

              {/* Groups */}
              <InspectSubtitle title={messages.groups} />

              <FormToManyField name="groups" renderNewOnButton>
                {({
                  name,
                  isNew,
                  push,
                  remove,
                  value,
                  index,
                  length,
                  plus
                }) => (
                  <Container
                    key={name}
                    flexDirection="row"
                    alignItems="center"
                    paddings="10px"
                  >
                    {isMutable ? (
                      <DeletableItem
                        allowDelete={!isNew}
                        height="60px"
                        confirmMessage={messages.confirmDeleteItem}
                        onConfirm={remove}
                        checkPermissions={{
                          objects: "ApplicationUserUserGroup",
                          actions: ["delete"]
                        }}
                      >
                        {/* Group or add icon */}
                        <RoundedIcon
                          iconSize={50}
                          color={
                            theme.roundedIconColor ||
                            theme.fieldFontColor ||
                            theme.fontColor
                          }
                          name={isNew ? "plus-circle" : "users"}
                        />
                      </DeletableItem>
                    ) : (
                      <RoundedIcon
                        iconSize={50}
                        color={
                          theme.roundedIconColor ||
                          theme.fieldFontColor ||
                          theme.fontColor
                        }
                        name={isNew ? "plus-circle" : "users"}
                      />
                    )}

                    {/* Group select field */}
                    <FormSelectRecordField
                      query={findUserGroupsByNameQuery}
                      variables={{
                        ...wrapBusiness({ name: "" }),
                        startIndex: 0,
                        stopIndex: 50
                      }}
                      name={name}
                      placeholder={messages.selectGroup}
                      onChangeText={push}
                      margins="0 0 0 10px"
                      width="200px"
                      // enableRefresh
                      // User Groups that already form part of the array must not be shown in SelectRecordField
                      excludeValues={{
                        values: value,
                        equalsFn: (groupOption, groupValue) =>
                          groupOption &&
                          groupValue &&
                          groupOption.id === groupValue.id
                      }}
                      isDisabled={!isMutable}
                    />

                    {/* New Item Button */}
                    <SecuredComponent
                      checkPermissions={{
                        objects: "ApplicationUserUserGroup",
                        actions: ["create"]
                      }}
                    >
                      {!isNew &&
                        index + 1 === length &&
                        theme.renderNewOnButton &&
                        isMutable ? (
                        <Button
                          leftIcon="plus"
                          margins="0 0 0 10px"
                          ui="dangerLink"
                          leftIconWeight={900}
                          onPress={plus}
                        />
                      ) : null}
                    </SecuredComponent>
                  </Container>
                )}
              </FormToManyField>

              {/* BUSINESSES */}
              {!theme.hideUserBusinesses && (<InspectSubtitle title={messages.additionalBusinessAccess} />)}

              {!theme.hideUserBusinesses && (
                <FormToManyField name="userBusinesses" renderNewOnButton>
                  {({
                    name,
                    isNew,
                    push,
                    remove,
                    value,
                    index,
                    length,
                    plus
                  }) => (
                    <Container
                      key={name}
                      flexDirection="row"
                      alignItems="center"
                      paddings="10px"
                    >
                      {isMutable ? (
                        <DeletableItem
                          allowDelete={!isNew}
                          height="60px"
                          confirmMessage={messages.confirmDeleteItem}
                          onConfirm={() => {
                            // TODO This is a Workaround. Correct fix is to UPGRADE ARRAY FIELDS.
                            // These are similar bugs:
                            // https://github.com/final-form/react-final-form-arrays/issues/56
                            // https://github.com/final-form/react-final-form-arrays/issues/107
                            // I tried to upgrade it and the result was an error:
                            // "useField must be used inside of a <Form> component".
                            if (length - 1 === index) {
                              const nn = form.getFieldState("contact.firstName").value;
                              form.change("contact.firstName", nn && nn.slice(-1) === " " ? nn.slice(0, -1) : nn + " ");
                            }
                            remove();
                          }}
                          checkPermissions={{
                            objects: "ApplicationUserBusiness",
                            actions: ["delete"]
                          }}
                        >
                          {/* Group or add icon */}
                          <RoundedIcon
                            iconSize={50}
                            color={
                              theme.roundedIconColor ||
                              theme.fieldFontColor ||
                              theme.fontColor
                            }
                            name={isNew ? "plus-circle" : "building"}
                          />
                        </DeletableItem>
                      ) : (
                        <RoundedIcon
                          iconSize={50}
                          color={
                            theme.roundedIconColor ||
                            theme.fieldFontColor ||
                            theme.fontColor
                          }
                          name={isNew ? "plus-circle" : "building"}
                        />
                      )}

                      {/* Business select field */}
                      <FormSelectRecordField
                        query={findBusinessesByNameQuery}
                        enableServerSearch
                        name={name}
                        labelKey="contact.companyName"
                        // placeholder={messages.selectGroup}
                        onChangeText={push}
                        margins="0 0 0 10px"
                        width="200px"
                        // enableRefresh
                        // User Groups that already form part of the array must not be shown in SelectRecordField
                        excludeValues={{
                          values: value,
                          equalsFn: (groupOption, groupValue) =>
                            groupOption &&
                            groupValue &&
                            groupOption.id === groupValue.id
                        }}
                        isDisabled={!isMutable}
                      />

                      {/* New Item Button */}
                      <SecuredComponent
                        checkPermissions={{
                          objects: "ApplicationUserBusiness",
                          actions: ["create"]
                        }}
                      >
                        {!isNew &&
                          index + 1 === length &&
                          theme.renderNewOnButton &&
                          isMutable ? (
                          <Button
                            leftIcon="plus"
                            margins="0 0 0 10px"
                            ui="dangerLink"
                            leftIconWeight={900}
                            onPress={plus}
                          />
                        ) : null}
                      </SecuredComponent>
                    </Container>
                  )}
                </FormToManyField>
              )}

              {/* More items/components */}
              {MoreItems && <MoreItems />}

              {/* Modal for business selection */}
              <ToastContext.Consumer>
                {toast => (
                  <BusinessSelectionDialog
                    isVisible={businessVisible}
                    onBackdropPress={() => setBusinessVisible(false)}
                    onSelected={() => {
                      toast.success(messages.userMovedOK);
                      setBusinessVisible(false)

                      // Redirect the user to the root path since the record no longer exists.
                      setTimeout(() => {
                        // history.replace("/");
                        history.replace(restProps.rootPath);
                      }, 750);
                    }}
                    userId={restProps.match.params.id}
                    change // change business
                  />
                )}
              </ToastContext.Consumer>
            </React.Fragment>
          )}
        </SessionQuery>
      )}
    </InspectComponent>
  );
};

export default graphql(getSessionInformation)(withApollo(withRouter(withTheme(injectIntl(Inspect)))));
